<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        事業者管理 - 新規登録
        <div class="headerBtn" @click="screenTransition()" style="margin: 0px 0px 0px 20px;">一覧に戻る</div>
      </div>
      <p style="text-align: left; margin: 0px 0px 20px 30px">
        以下情報を入力し登録が完了すると、入力したログインID・パスワードで事業者としてログイン可能となります。<br>
        パスワードは登録後に確認することができませんので、必ず入力内容を控えて下さい。<br>
      </p>
      <!-- ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div v-if="getLodingFlg" style="padding: 0px 0px 30px 0px;">Now loading...</div>
        <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <form v-if="!getLodingFlg && !getErrorFlg">
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              アカウント情報
            </div>
            <div class="row">
              <p class="inputTitle editable">ログインID</p>
              <validation-provider name="ログインID" rules="required|min:4|max:96|loginId" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.loginId" placeholder="example.company">
                  <div v-if="idCheckFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
                    <div　class="errMsg">
                      <div class="errDiv">
                        既に登録されているログインIDです.</br>
                        {{loginIdCheckMessage}}
                      </div>
                    </div>
                  </div>
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">事業者名</p>
              <validation-provider name="事業者名" rules="required|max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.companyName" placeholder="株式会社TEST">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">建設許可番号</p>
              <validation-provider name="建設許可番号" rules="max:16" mode="lazy">
                <!-- TODO 桁数 -->
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.constructionNo" placeholder="0123456789123456">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">メールアドレス</p>
              <validation-provider name="メールアドレス" rules="required|emailVaridate|max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.email" placeholder="xxxxxx@xxx.xxx">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">パスワード</p>
              <validation-provider name="パスワード" rules="required|min:8|max:64|password" vid="confirmation" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="password" class="text large" v-model="detail.password" placeholder="8桁以上の半角英数記号">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">パスワード確認</p>
              <validation-provider name="パスワード確認" rules="required|confirmed:confirmation|min:8|max:64|password" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="password" class="text large" v-model="detail.confirm" placeholder="先ほど入力したパスワードを再度ご入力下さい">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>
          <!-- ローディング -->
          <div v-if="postLodingFlg">
            <vue-loading
              type="cylon"
              color="#1b7e47"
              :size="{ width: '150px', height: '150px' }"
            >
            </vue-loading>
            <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
          </div>
          <!-- 登録エラー表示 -->
          <div v-if="postErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
            <div　class="errMsg">
              <div class="errDiv">
                データの登録中に問題が発生しました。
              </div>
            </div>
          </div>
          <!-- 登録ボタン -->
          <div class="buttonGroup" v-if="!postLodingFlg">
            <button class="btn" type=button @click="confirm(detail)"
              v-bind:class="{ disabled: isProcessing() || ObserverProps.invalid || !ObserverProps.validate, active: !ObserverProps.invalid && ObserverProps.validate }"
              :disabled="ObserverProps.invalid">登録
            </button>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';
import common from '../services/common';

export default {
  title: '事業者登録',
  name: 'BusinessAdd',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
  },

  // setup() {
  //   return {
  //   },
  // },
  data() {
    return {
      num: '',
      idCheckFlg: false,
      // 登録用モデル
      detail: {
        loginId: '',
        email: '',
        constructionNo: '',
        password: '',
        confirm: '',
        companyName: '',
      },
      // ローディング
      getLodingFlg: false,  // データ取得時ローディング用フラグ
      getErrorFlg: false,   // データ取得時エラーフラグ
      postLodingFlg: false, // データ登録時ローディングフラグ
      postErrorFlg: false,  // データ登録時エラーフラグ
      processing: false,
      errorMessage: '',
      loginIdCheckMessage: '',
    };
  },
  // 初期処理
  async mounted() {
    try {
      // ローディング表示
      this.getLodingFlg = true;
      await this.callGetNumbering();
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    async callGetNumbering() {
      // 採番取得API
      const restResourceService = new ApiClient();
      this.num = await restResourceService.getNumbering('company');
      const number =  (('00000' + this.num).slice(-5));
      this.detail.loginId = 'EPCR2-' + number;
    },
    async callGetLoginIdcheck() {
      // 採番取API
      const restResourceService = new ApiClient();
      this.idCheckFlg = await restResourceService.getLoginIdcheck(this.detail.loginId);
    },
    async callUpdateNumbering() {
      // 採番更新API
      const restResourceService = new ApiClient();
      await restResourceService.updateNumbering('company');
    },
    // 登録ボタン押下時 登録処理
    async confirm(detail) {
      await this.startProcessing();
      // ローディング表示
      this.postLodingFlg = true;
      // エラーフラグ初期化
      this.postErrorFlg = false;
      // ====================入力項目空白削除====================
      // if(!detail.email){
      //   detail.email = 'example@example.jp';
      // }
      // 採番重複チェック
      try {
        // 採番重複チェック
        await this.callGetLoginIdcheck();
        // ログインIDが重複していた場合
        if (this.idCheckFlg) {
          // ログインIDが自動採番分の場合
          if(detail.loginId.match(/EPCR2-/)){
            await this.callGetNumbering('company');
            this.loginIdCheckMessage = '新しく取得したログインIDで再度ご登録をお願い致します．';
            throw('');
          // 任意入力の場合
          } else {
            this.loginIdCheckMessage = '別のログインIDをご入力下さい．';
            throw('');
          }
        }
      } catch (error) {
        this.errorMessage = error.message;
        this.postLodingFlg = false;
        this.endProcessing();
        return;
      }
      detail.email = detail.email.trim();
      detail.companyName = detail.companyName.trim();
      try {
        // cognitoへ事業者権限アカウントを新規登録
        await this.$cognito.signUp(detail.loginId, detail.email, detail.password, '3');
        // ステータスを確認済みに変更
        await this.$cognito.setUserPassword(detail.loginId, detail.email, detail.password);
        // 事業者新規登録API呼出
        const body = {
          constructionNo: detail.constructionNo,
          loginId: detail.loginId,
          email: detail.email,
          password: detail.password,
          companyName: detail.companyName,
        };
        const restResourceService = new ApiClient();
        await restResourceService.postCompany(body);
        await restResourceService.postNumbering(body.loginId);
        await this.callUpdateNumbering();
        this.screenTransition();
      } catch (error) {
        this.errorMessage = error.message;
        this.postErrorFlg = true;
      } finally {
        // ローディング非表示
        this.postLodingFlg = false;
        this.endProcessing();
      }
    },
    trimIn() {
      this.detail.constructionNo = common.trimSpace(this.detail.constructionNo);
    },
    // 画面遷移
    screenTransition() {
      history.back();
    },
    // チャタリング防止
    async startProcessing() {
      this.processing = true;
    },
    async endProcessing() {
      this.processing = false;
    },
    async isProcessing() {
      return this.processing;
    },
  },
  filters: {
    filterZip(d) {
      const buf = ('0000000' + d).slice(-7);
      return buf;
      // return isNaN(buf) ? '1000000' : buf;
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";
.selectdiv {
  position: relative;
  float: left;
  min-width: 494px;
}

.selectdiv:after {
  content: '>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  top: 18px;
  padding: 0 0 2px;
  border-bottom: 1px solid #999;
  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Add some styling */

  display: block;
  width: 100%;
  max-width: 494px;
  height: 45px;
  float: right;
  margin: 5px 0px;
  padding: 0px 20px;
  font-size: 20px;
  line-height: 1.75;
  color: #333;
  background-color: #ffffff;
  background-image: none;
  border: 2px solid #000000;
  border-radius:10px;
  -ms-word-break: normal;
  word-break: normal;
}

</style>
